export const translations = {
  en: {
    account: "Account",
    notifications: "Notifications",
    content: "Content",
    health: "Health Information",
    accessibility: "Accessibility",
    privacy: "Data & Privacy",
    accesshistory: "Access History",
    logout: "Logout",
    deactivate: "Deactivate Account",
    languagePreference: "Language Preference",
    english: "English",
    tagalog: "Tagalog",

    // Top Navigation Bar
    learn: "Learn",
    askAuri: "Ask Auri",
    records: "Records",
    appointment: "Appointment",
    notifications: "Notifications",
    profile: "Profile",

    // Learn Panel
    educationalHub: "Educational Hub",
    suggestedArticles: "Suggested Articles",
    upNext: "Up Next",
    search: "Search",

    // Ask AI Panel
    newChat: "New Chat",
    searchChats: "Search Chats",
    open: "Open",
    archived: "Archived",
    typeYourMessage: "Type your message",

    // Human Support Panel
    humanSupport: "Human Support",
    hiThereYoureAboutToChat: "Hi there! You're about to chat with an AuraVit Peer Educator.",
    greatChoosePreferredLanguage: "Great! Before we continue, please choose your preferred language so we can match you with a Peer Educator who you can communicate comfortably with.",
    english: "English",
    tagalog: "Tagalog",
    bisaya: "Bisaya",
    excellentChooseTopic: "Excellent! To help us better assist you, what topic is your inquiry about?",
    hivAwareness: "HIV Awareness",
    hivScreeningTesting: "HIV Screening/Testing",
    birthControlImplant: "Birth Control/Implant",
    contraception: "Contraception",
    familyPlanning: "Family Planning",
    genderBasedViolence: "Gender-Based Violence",
    menstrualHealthHygiene: "Menstrual Health & Hygiene",
    other: "Other",
    thankYouForSharing: "Thank you for sharing. You can now send your question or message, and our Peer Educator will be ready to assist you.",
    excellentYouCanSendMessage: "Excellent! You can go ahead and send your question or message whenever you're ready.",
    yourInquirySubmittedTicket: "Your inquiry has been submitted! Ticket number:",
    waitingForPeerEducator: "Waiting for a peer educator...",

    // Records Panel
    healthRecords: "Health Records",
    all: "All",
    uncategorized: "Uncategorized",
    searchRecords: "Search Records",
    addCategory: "Add Category",
    noRecordsFound: "No records found",

    // Appointments Panel
    appointments: "Appointments",
    bookAppointment: "Book Appointment",
    myAppointments: "My Appointments",
    upcoming: "Upcoming",
    completed: "Completed",
    cancelled: "Cancelled",
    searchAppointments: "Search Appointments",

    // Notifications Panel
    notificationSettings: "Notification Settings",
    chooseWhatNotifications: "Choose what notifications you want to receive. We'll still send important account updates.",
    enabled: "Enabled",
    disabled: "Disabled",
    active: "Active",
    educationalContent: "Educational Content",
    educationalContentDesc: "Get notified about learning materials, health tips, and educational updates.",
    eventsActivities: "Events & Activities",
    eventsActivitiesDesc: "Receive alerts for upcoming events, workshops, and community activities.",
    systemAnnouncements: "System Announcements",
    systemAnnouncementsDesc: "Stay informed with important news, system updates, and critical notices.",
    appointmentReminders: "Appointment Reminders",
    appointmentRemindersDesc: "Get timely reminders and updates about your upcoming appointments.",
    dataPrivacy: "Data Privacy",
    dataPrivacyDesc: "Get notified about data access requests and privacy updates.",
    importantNotificationsAlwaysDelivered: "Important notifications about your account and security will always be delivered.",
    enableAll: "Enable All",
    disableAll: "Disable All",
    noNotifications: "No notifications",
    noNotificationsInCategory: "You have no notifications in this category yet.",

    // UserProfile - Account Information
    accountSettings: "Account Settings",
    managePersonalInfo: "Manage your personal information and preferences",
    editProfile: "Edit Profile",
    personalInformation: "Personal Information",
    editPersonalInformation: "Edit your personal information",
    dateOfBirth: "Date of Birth",
    sexAssignedAtBirth: "Sex at Birth",
    address: "Address",
    viewManageAccountDetails: "View and manage your account details",
    password: "Password",
    newPasswordDifferent: "Your new password must be different from your previous passwords",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    cancel: "Cancel",
    updateChanges: "Update Changes",
    updating: "Updating...",

    // UserProfile - Content Preferences
    contentPreferences: "Content Preferences",
    personalizeLearningJourney: "Personalize your learning journey with topics that resonate with your health goals",

    // UserProfile - Health Information
    healthHistory: "Health History",
    infoShareTailorGuidance: "Information you choose to share helps tailor guidance and care.",

    // UserProfile - Accessibility
    customizeExperience: "Customize your experience by selecting your preferred language and text size",
    preferredLanguage: "Preferred Language",
    selectLanguage: "Select Language",
    textSize: "Text Size",
    small: "Small",
    medium: "Medium",
    large: "Large",
    previewTextSize: "Preview Text Size",

    // UserProfile - Data & Privacy
    monitorManageAccess: "Monitor and manage access to your personal health information",
    pending: "Pending",
    approved: "Approved",
    pendingRequests: "Pending Requests",
    approvedAccess: "Approved Access",
    noPendingAccessRequests: "No pending access requests.",

    // UserProfile - Access History
    reviewPastCurrentAccess: "Review past and current access to your personal health information",
    active: "Active",
    expired: "Expired",
    noAccessHistoryFound: "No access history found.",

    // Logout Modal
    readyToLeave: "Ready to leave?",
    sessionEndRedirect: "Your session will end and you'll be redirected to the login page. You can always come back later!",
    stayLoggedIn: "Stay logged in",
    logout: "Log out",
    yourDataSafelySaved: "Your data is safely saved",

    // Deactivate Modal - Step 1
    thinkingAboutLeaving: "Thinking about leaving?",
    understandSometimesNeedBreak: "We understand sometimes you need a break. Here's what happens when you deactivate your account:",
    temporaryPause: "Temporary Pause",
    profileHiddenButDataStored: "Your profile is hidden but your data is safely stored for 30 days",
    easyReactivation: "Easy Reactivation",
    logBackInWithin30Days: "Simply log back in within 30 days to restore your account",
    noNotifications: "No Notifications",
    noNotificationsWhileDeactivated: "You won't receive any notifications while deactivated",
    accountLifecyclePolicy: "Account Lifecycle Policy",
    toMaintainSystemIntegrity: "To maintain system integrity and data security, inactive accounts follow a structured lifecycle:",
    twelveMonthsInactive: "12 months inactive → Marked as dormant",
    thirtyDaysAfterNotification: "30 days after notification → Temporary deactivation",
    threeYearsInactive: "3 years inactive → Archived (requires verification to restore)",
    dataNeverDeleted: "Your data is never deleted unless required by law or explicitly requested.",
    keepMyAccountActive: "Keep my account active",
    actionIsReversible: "This action is reversible. You can reactivate anytime within 30 days.",
    deactivateAccount: "Deactivate Account",

    // Deactivate Modal - Step 2 (Password)
    securityVerification: "Security verification",
    forYourProtectionEnterPassword: "For your protection, please enter your password to confirm account deactivation.",
    whyWeNeedYourPassword: "Why we need your password",
    extraStepEnsuresOnlyYou: "This extra step ensures that only you can make changes to your account.",
    deactivationReason: "Deactivation Reason",
    enterDeactivationReason: "Enter deactivation reason",
    passwordRequired: "Password is required",
    deactivationReasonRequired: "Deactivation reason is required",
    deactivationReasonLettersOnly: "Deactivation reason must contain letters only",
    deactivationReason20Chars: "Deactivation reason must be 20 characters or less",
    sessionExpiredPleaseLogIn: "Session expired. Please log in again.",
    incorrectPasswordPleaseTryAgain: "Incorrect password. Please try again.",
    verifying: "Verifying...",
    continue: "Continue",
    yourPasswordEncrypted: "Your password is encrypted and securely transmitted.",

    // Deactivate Modal - Step 3 (OTP)
    confirmDeactivation: "Confirm Deactivation",
    weSentOtpToEmail: "We've sent a one-time passcode (OTP) to your email. Please enter it to confirm deactivation.",
    otp: "OTP",
    enterOtp: "Enter OTP",
    otpRequired: "OTP is required",
    otpMustBe6Digits: "OTP must be 6 digits",
    invalidOtp: "Invalid OTP. Please try again.",
    resendOtp: "Resend OTP",
    otpSent: "OTP sent!",
    confirm: "Confirm",
    confirming: "Confirming...",
    makeSureCheckSpam: "Make sure to check your spam folder if you don't see the email.",
    emailNotFoundPleaseTryAgain: "Email not found. Please try again.",
    failedToSendVerificationCode: "Failed to send verification code. Please try again.",
    pleaseEnterFull6DigitCode: "Please enter the full 6-digit code",
    codeHasExpiredPleaseRequestNew: "Code has expired. Please request a new code.",
    noPendingDeactivationFound: "No pending deactivation found. Please try again.",
    incorrectCodePleaseTryAgain: "Incorrect code, please try again",
    deactivationFailedPleaseTryAgain: "Deactivation failed. Please try again.",
    failedToResendCode: "Failed to resend code. Please try again.",
    checkYourEmail: "Check your email",
    weSent6DigitCode: "We've sent a 6-digit verification code to confirm your deactivation request.",
    verificationSent: "Verification sent",
    checkInboxEnterCode: "Check your inbox and enter the 6-digit code below",
    whyWeNeedVerification: "Why we need verification",
    extraStepEnsuresOnlyCompleteDeactivation: "This extra step ensures that only you can complete the deactivation process.",
    codeExpiresIn: "Code expires in",
    didntReceiveCode: "Didn't receive the code?",
    sending: "Sending...",

    // Ask AI Panel - Onboarding
    heyThereImAuri: "Hey there! I'm Auri, your health sidekick.",
    beforeWeGetStarted: "Before we get started, I just need to let you know something important. This conversation is not intended as a substitute for professional medical advice, diagnosis, or treatment. Always consult your healthcare provider for any medical concerns.",
    iUnderstand: "I Understand",
    thanksForConfirming: "Thanks for confirming! I'm here to answer your reproductive health questions using AuraVit's health FAQs. Ask me about topics like HIV awareness, HIV testing, birth control, and other reproductive health concerns.",
    letsGetStarted: "Let's get started",
    awesomeLetsDiveIn: "Awesome! I'm here to help. Feel free to ask me any reproductive health question, and I'll provide information based on AuraVit's verified health FAQs.",
    hiThereHumanSupport: "Hi there! You're about to chat with an AuraVit Peer Educator.",
    greatYouCanSendQuestion: "Great! You can go ahead and send your question or message whenever you're ready.",
  },
  
  // Admin Translations
  admin: {
    // Admin Profile
    adminProfile: "Admin Profile",
    accountSettings: "Account Settings",
    personalInformation: "Personal Information",
    fullName: "Full Name",
    email: "Email",
    phoneNumber: "Phone Number",
    dateOfBirth: "Date of Birth",
    sexAssignedAtBirth: "Sex Assigned at Birth",
    address: "Address",
    preferredLanguage: "Preferred Language",
    selectLanguage: "Select Language",
    english: "English",
    filipino: "Filipino",
    saveChanges: "Save Changes",
    cancel: "Cancel",
    editingProfile: "Editing Profile",
    editProfile: "Edit Profile",
    dateCreated: "Date Created",
    lastLogin: "Last Login",
    activeSessions: "Active Sessions",
    
    // Admin Content
    contentLibrary: "Content Library",
    pending: "Pending",
    revisions: "Revisions",
    rejected: "Rejected",
    archived: "Archived",
    published: "Published",
    search: "Search",
    filterByCategory: "Filter by Category",
    allCategories: "All Categories",
    creator: "Creator",
    title: "Title",
    category: "Category",
    submittedDate: "Submitted Date",
    decisionDate: "Decision Date",
    actions: "Actions",
    approve: "Approve",
    reject: "Reject",
    revise: "Revise",
    archive: "Archive",
    restore: "Restore",
    delete: "Delete",
    revisionDate: "Revision Date",
    applyRevision: "Apply Revision",
    rejectRevision: "Reject Revision",
    reasonForRejection: "Reason for Rejection",
    noContentFound: "No content found",
    archiveContent: "Archive Content",
    restoreContent: "Restore Content",
    deleteContent: "Delete Content",
    approveContent: "Approve Content",
    rejectContent: "Reject Content",
    thisActionCannotBeUndone: "This action cannot be undone.",
    archiveWarning: "Are you sure you want to archive this content?",
    restoreWarning: "Are you sure you want to restore this content?",
    deleteWarning: "Are you sure you want to delete this content?",
    approveWarning: "Are you sure you want to approve this content?",
    rejectWarning: "Are you sure you want to reject this content?",
    applyRevisionWarning: "Are you sure you want to apply this revision?",
    rejectRevisionWarning: "Are you sure you want to reject this revision?",
    prev: "Previous",
    next: "Next",
    of: "of",
    viewRevision: "View Revision",
    viewContent: "View Content",
    
    // Admin Dashboard
    dashboard: "Dashboard",
    contentManagement: "Content Management",
    peerResources: "Peer Resources",
    escalatedCases: "Escalated Cases",
    recentActivity: "Recent Activity",
    totalContent: "Total Content",
    pendingApproval: "Pending Approval",
    publishedContent: "Published Content",
    totalPeers: "Total Peers",
    activeCases: "Active Cases",
    reviewAndManageContent: "Review and manage submitted content for approval",
    profile: "Profile",
    
    // General
    loading: "Loading...",
    error: "Error",
    success: "Success",
    confirmation: "Confirmation",
    areYouSure: "Are you sure?",
    thisActionCannotBeUndone: "This action cannot be undone.",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    previous: "Previous",
    submit: "Submit",
    
    // Escalation
    escalationDetails: "Escalation Details",
    escalationFormTitle: "Escalation Form",
  },
  
  adminTl: {
    // Admin Profile
    adminProfile: "Profile ng Admin",
    accountSettings: "Mga Setting ng Account",
    personalInformation: "Personal na Impormasyon",
    fullName: "Pangalan",
    email: "Email",
    phoneNumber: "Numero ng Telepono",
    dateOfBirth: "Petsa ng Kapanganakan",
    sexAssignedAtBirth: "Kasarian Ipinanganak",
    address: "Address",
    preferredLanguage: "Gustong Wika",
    selectLanguage: "Pumili ng Wika",
    english: "English",
    filipino: "Filipino",
    saveChanges: "I-save ang Mga Pagbabago",
    cancel: "Kanselahin",
    editingProfile: "Nag-eedit ng Profile",
    editProfile: "I-edit ang Profile",
    dateCreated: "Petsa ng Nilikha",
    lastLogin: "Huling Pag-login",
    activeSessions: "Mga Aktibong Session",
    
    // Admin Content
    contentLibrary: "Library ng Nilalaman",
    pending: "Naka-pending",
    revisions: "Mga Rebisyon",
    rejected: "Nareject",
    archived: "Naka-archive",
    published: "Nai-publish",
    search: "Maghanap",
    filterByCategory: "I-filter ayon sa Kategory",
    allCategories: "Lahat ng Kategory",
    creator: "May-likha",
    title: "Pamagat",
    category: "Kategory",
    submittedDate: "Petsa ng Pagsumite",
    decisionDate: "Petsa ng Desisyon",
    actions: "Mga Aksyon",
    approve: "I-approve",
    reject: "I-reject",
    revise: "I-revise",
    archive: "I-archive",
    restore: "I-restore",
    delete: "I-delete",
    revisionDate: "Petsa ng Rebisyon",
    applyRevision: "I-apply ang Rebisyon",
    rejectRevision: "I-reject ang Rebisyon",
    reasonForRejection: "Dahilan ng Rejection",
    noContentFound: "Walang nahanap na nilalaman",
    archiveContent: "I-archive ang Nilalaman",
    restoreContent: "I-restore ang Nilalaman",
    deleteContent: "I-delete ang Nilalaman",
    approveContent: "I-approve ang Nilalaman",
    rejectContent: "I-reject ang Nilalaman",
    thisActionCannotBeUndone: "Hindi na mababalik ang aksyong ito.",
    archiveWarning: "Sigurado ka ba na gusto mong i-archive ang nilalaman na ito?",
    restoreWarning: "Sigurado ka ba na gusto mong i-restore ang nilalaman na ito?",
    deleteWarning: "Sigurado ka ba na gusto mong i-delete ang nilalaman na ito?",
    approveWarning: "Sigurado ka ba na gusto mong i-approve ang nilalaman na ito?",
    rejectWarning: "Sigurado ka ba na gusto mong i-reject ang nilalaman na ito?",
    applyRevisionWarning: "Sigurado ka ba na gusto mong i-apply ang rebisyon na ito?",
    rejectRevisionWarning: "Sigurado ka ba na gusto mong i-reject ang rebisyon na ito?",
    prev: "Nakaraan",
    next: "Susunod",
    of: "ng",
    viewRevision: "Tingnan ang Rebisyon",
    viewContent: "Tingnan ang Nilalaman",
    
    // Admin Dashboard
    dashboard: "Dashboard",
    contentManagement: "Pamahalaan ng Nilalaman",
    peerResources: "Mga Resource ng Peer",
    escalatedCases: "Mga Kaso na Naka-escalate",
    recentActivity: "Kamakailang Aktibidad",
    totalContent: "Kabuuan ng Nilalaman",
    pendingApproval: "Naka-pending na Approval",
    publishedContent: "Nai-publish na Nilalaman",
    totalPeers: "Kabuuan ng mga Peer",
    activeCases: "Mga Aktibong Kaso",
    reviewAndManageContent: "Suriin at pamahalaan ang na-sumit na nilalaman para sa approval",
    
    // General
    loading: "Naglo-load...",
    error: "Error",
    success: "Tagumpay",
    confirmation: "Kumpirmasyon",
    areYouSure: "Sigurado ka ba?",
    thisActionCannotBeUndone: "Hindi na mababalik ang aksyong ito.",
    confirm: "Kumpirmahin",
    back: "Bumalik",
    next: "Susunod",
    previous: "Nakaraan",
    submit: "Isumite",
    
    // Escalation
    escalationDetails: "Mga Detalye ng Escalation",
    escalationFormTitle: "Form ng Escalation",
  },

  // Content Curator Translations
  contentCurator: {
    // Content Profile
    contentProfile: "Profile ng Content Curator",
    accountSettings: "Mga Setting ng Account",
    personalInformation: "Personal na Impormasyon",
    fullName: "Pangalan",
    email: "Email",
    phoneNumber: "Numero ng Telepono",
    dateOfBirth: "Petsa ng Kapanganakan",
    sexAssignedAtBirth: "Kasarian Ipinanganak",
    address: "Address",
    preferredLanguage: "Gustong Wika",
    selectLanguage: "Pumili ng Wika",
    english: "English",
    filipino: "Filipino",
    saveChanges: "I-save ang Mga Pagbabago",
    cancel: "Kanselahin",
    editingProfile: "Nag-eedit ng Profile",
    editProfile: "I-edit ang Profile",
    dateCreated: "Petsa ng Nilikha",
    lastLogin: "Huling Pag-login",
    activeSessions: "Mga Aktibong Session",

    // Content Dashboard
    dashboard: "Dashboard",
    contentLibrary: "Library ng Nilalaman",
    announcements: "Mga Anunsyo",
    newContent: "Bagong Nilalaman",
    mySubmissions: "Aking Mga Sumite",
    totalPublished: "Kabuuan ng Nai-publish",
    pendingReview: "Naka-pending na Review",
    revisions: "Mga Rebisyon",

    // Content Library
    search: "Maghanap",
    filterByCategory: "I-filter ayon sa Kategory",
    allCategories: "Lahat ng Kategory",
    title: "Pamagat",
    category: "Kategory",
    submittedDate: "Petsa ng Pagsumite",
    status: "Status",
    actions: "Mga Aksyon",
    noContentFound: "Walang nahanap na nilalaman",
    published: "Nai-publish",
    pending: "Naka-pending",
    rejected: "Nareject",
    archived: "Naka-archive",
    view: "Tingnan",
    edit: "I-edit",
    delete: "I-delete",

    // New Content
    createNewContent: "Lumikha ng Bagong Nilalaman",
    title: "Pamagat",
    category: "Kategory",
    content: "Nilalaman",
    submit: "Isumite",
    preview: "I-preview",
    saveDraft: "I-save ang Draft",
    publishing: "Naglul-publish...",
    saving: "Nagse-save...",

    // Announcements
    createAnnouncement: "Lumikha ng Anunsyo",
    announcementTitle: "Pamagat ng Anunsyo",
    announcementContent: "Nilalaman ng Anunsyo",
    targetAudience: "Target na Audiens",
    publish: "I-publish",
    schedule: "Iskedyul",
    draft: "Draft",

    // Revisions
    viewRevision: "Tingnan ang Rebisyon",
    applyRevision: "I-apply ang Rebisyon",
    rejectRevision: "I-reject ang Rebisyon",
    revisionHistory: "Kasaysayan ng Rebisyon",
    reasonForRevision: "Dahilan ng Rebisyon",

    // General
    loading: "Naglo-load...",
    error: "Error",
    success: "Tagumpay",
    back: "Bumalik",
    confirm: "Kumpirmahin",
    areYouSure: "Sigurado ka ba?",
    thisActionCannotBeUndone: "Hindi na mababalik ang aksyong ito.",
    selectCategory: "Pumili ng isang kategory",
    contentSettings: "Mga Setting ng Content",
    socialPreview: "Social Preview",
    editSocial: "I-edit ang Social",
    publishToApproval: "I-publish para sa Approval",
    saveAsDraft: "I-save bilang Draft",
    minorEligible: "Minor Eligible",
    publish: "I-publish",
    save: "I-save",
    pleaseAddContent: "Mangyaring magdagdag ng content bago magsumite para sa approval.",
    pleaseSelectCategory: "Mangyaring pumili ng kategory bago magsumite para sa approval.",
    submissionSuccess: "Ang content ay na-submit para sa approval!",
    draftSaved: "Ang draft ay na-save nang matagumpay!",
    description: "Deskripsyon",
    loadMoreData: "Mag-load ng karagdagang data",
    loadingMore: "Naglo-load ng karagdagang...",
  },

  contentCuratorEn: {
    // Content Profile
    contentProfile: "Content Curator Profile",
    accountSettings: "Account Settings",
    personalInformation: "Personal Information",
    fullName: "Full Name",
    email: "Email",
    phoneNumber: "Phone Number",
    dateOfBirth: "Date of Birth",
    sexAssignedAtBirth: "Sex at Birth",
    address: "Address",
    preferredLanguage: "Preferred Language",
    selectLanguage: "Select Language",
    english: "English",
    filipino: "Filipino",
    saveChanges: "Save Changes",
    cancel: "Cancel",
    editingProfile: "Editing Profile",
    editProfile: "Edit Profile",
    dateCreated: "Date Created",
    lastLogin: "Last Login",
    activeSessions: "Active Sessions",

    // Content Dashboard
    dashboard: "Dashboard",
    contentLibrary: "Content Library",
    announcements: "Announcements",
    newContent: "New Content",
    mySubmissions: "My Submissions",
    totalPublished: "Total Published",
    pendingReview: "Pending Review",
    revisions: "Revisions",

    // Content Library
    search: "Search",
    filterByCategory: "Filter by Category",
    allCategories: "All Categories",
    title: "Title",
    category: "Category",
    submittedDate: "Submitted Date",
    status: "Status",
    actions: "Actions",
    noContentFound: "No content found",
    published: "Published",
    pending: "Pending",
    rejected: "Rejected",
    archived: "Archived",
    view: "View",
    edit: "Edit",
    delete: "Delete",

    // New Content
    createNewContent: "Create New Content",
    title: "Title",
    category: "Category",
    content: "Content",
    submit: "Submit",
    preview: "Preview",
    saveDraft: "Save Draft",
    publishing: "Publishing...",
    saving: "Saving...",

    // Announcements
    createAnnouncement: "Create Announcement",
    announcementTitle: "Announcement Title",
    announcementContent: "Announcement Content",
    targetAudience: "Target Audience",
    publish: "Publish",
    schedule: "Schedule",
    draft: "Draft",

    // Revisions
    viewRevision: "View Revision",
    applyRevision: "Apply Revision",
    rejectRevision: "Reject Revision",
    revisionHistory: "Revision History",
    reasonForRevision: "Reason for Revision",

    // General
    loading: "Loading...",
    error: "Error",
    success: "Success",
    back: "Back",
    confirm: "Confirm",
    areYouSure: "Are you sure?",
    thisActionCannotBeUndone: "This action cannot be undone.",
    selectCategory: "Select one category",
    contentSettings: "Content Settings",
    socialPreview: "Social Preview",
    editSocial: "Edit Social",
    publishToApproval: "Publish to Approval",
    saveAsDraft: "Save as Draft",
    minorEligible: "Minor Eligible",
    publish: "Publish",
    save: "Save",
    pleaseAddContent: "Please add content before submitting for approval.",
    pleaseSelectCategory: "Please select a category before submitting for approval.",
    submissionSuccess: "Content submitted for approval!",
    draftSaved: "Draft saved successfully!",
    description: "Description",
    loadMoreData: "Load more data available",
    loadingMore: "Loading more...",
    
    // Escalation
    escalationDetails: "Escalation Details",
    escalationFormTitle: "Escalation Form",
  },

  // Peer Educator Translations
  peerEducator: {
    // Peer Profile
    peerProfile: "Peer Educator Profile",
    accountSettings: "Account Settings",
    personalInformation: "Personal Information",
    fullName: "Full Name",
    email: "Email",
    phoneNumber: "Phone Number",
    dateOfBirth: "Date of Birth",
    sexAssignedAtBirth: "Sex at Birth",
    address: "Address",
    preferredLanguage: "Preferred Language",
    selectLanguage: "Select Language",
    english: "English",
    filipino: "Filipino",
    saveChanges: "Save Changes",
    cancel: "Cancel",
    editingProfile: "Editing Profile",
    editProfile: "Edit Profile",
    dateCreated: "Date Created",
    lastLogin: "Last Login",
    activeSessions: "Active Sessions",

    // Peer Dashboard
    dashboard: "Dashboard",
    chat: "Chat",
    resources: "Resources",
    profile: "Profile",
    activeChats: "Active Chats",
    pendingRequests: "Pending Requests",
    totalResources: "Total Resources",
    recentActivity: "Recent Activity",

    // Peer Chats
    chats: "Chats",
    newChat: "New Chat",
    searchChats: "Search Chats",
    open: "Open",
    archived: "Archived",
    typeYourMessage: "Type your message",
    send: "Send",
    noChatsFound: "No chats found",
    chatHistory: "Chat History",

    // Peer Chat Form
    selectTopic: "Select Topic",
    hivAwareness: "HIV Awareness",
    hivScreeningTesting: "HIV Screening/Testing",
    birthControlImplant: "Birth Control/Implant",
    contraception: "Contraception",
    familyPlanning: "Family Planning",
    genderBasedViolence: "Gender-Based Violence",
    menstrualHealthHygiene: "Menstrual Health & Hygiene",
    other: "Other",
    specifyTopic: "Please specify your topic",
    submitRequest: "Submit Request",
    chatRequest: "Chat Request",
    waitingForPeer: "Waiting for peer educator...",

    // Peer Resources
    resourceLibrary: "Resource Library",
    search: "Search",
    filterByCategory: "Filter by Category",
    allCategories: "All Categories",
    title: "Title",
    category: "Category",
    addedDate: "Added Date",
    status: "Status",
    actions: "Actions",
    noResourcesFound: "No resources found",
    approved: "Approved",
    pending: "Pending",
    rejected: "Rejected",
    view: "View",
    edit: "Edit",
    delete: "Delete",
    addResource: "Add Resource",

    // Peer Resource View
    resourceDetails: "Resource Details",
    download: "Download",
    share: "Share",
    backToLibrary: "Back to Library",

    // General
    loading: "Loading...",
    error: "Error",
    success: "Success",
    back: "Back",
    confirm: "Confirm",
    areYouSure: "Are you sure?",
    thisActionCannotBeUndone: "This action cannot be undone.",
  },

  peerEducatorEn: {
    // Peer Profile
    peerProfile: "Peer Educator Profile",
    accountSettings: "Account Settings",
    personalInformation: "Personal Information",
    fullName: "Full Name",
    email: "Email",
    phoneNumber: "Phone Number",
    dateOfBirth: "Date of Birth",
    sexAssignedAtBirth: "Sex Assigned at Birth",
    address: "Address",
    preferredLanguage: "Preferred Language",
    selectLanguage: "Select Language",
    english: "English",
    filipino: "Filipino",
    saveChanges: "Save Changes",
    cancel: "Cancel",
    editingProfile: "Editing Profile",
    editProfile: "Edit Profile",
    dateCreated: "Date Created",
    lastLogin: "Last Login",
    activeSessions: "Active Sessions",

    // Peer Dashboard
    dashboard: "Dashboard",
    chat: "Chat",
    resources: "Resources",
    profile: "Profile",
    activeChats: "Active Chats",
    pendingRequests: "Pending Requests",
    totalResources: "Total Resources",
    recentActivity: "Recent Activity",

    // Peer Chats
    chats: "Chats",
    newChat: "New Chat",
    searchChats: "Search Chats",
    open: "Open",
    archived: "Archived",
    typeYourMessage: "Type your message",
    send: "Send",
    noChatsFound: "No chats found",
    chatHistory: "Chat History",

    // Peer Chat Form
    selectTopic: "Select Topic",
    hivAwareness: "HIV Awareness",
    hivScreeningTesting: "HIV Screening/Testing",
    birthControlImplant: "Birth Control/Implant",
    contraception: "Contraception",
    familyPlanning: "Family Planning",
    genderBasedViolence: "Gender-Based Violence",
    menstrualHealthHygiene: "Menstrual Health & Hygiene",
    other: "Other",
    specifyTopic: "Please specify your topic",
    submitRequest: "Submit Request",
    chatRequest: "Chat Request",
    waitingForPeer: "Waiting for peer educator...",

    // Peer Resources
    resourceLibrary: "Resource Library",
    search: "Search",
    filterByCategory: "Filter by Category",
    allCategories: "All Categories",
    title: "Title",
    category: "Category",
    addedDate: "Added Date",
    status: "Status",
    actions: "Actions",
    noResourcesFound: "No resources found",
    approved: "Approved",
    pending: "Pending",
    rejected: "Rejected",
    view: "View",
    edit: "Edit",
    delete: "Delete",
    addResource: "Add Resource",

    // Peer Resource View
    resourceDetails: "Resource Details",
    download: "Download",
    share: "Share",
    backToLibrary: "Back to Library",

    // General
    loading: "Loading...",
    error: "Error",
    success: "Success",
    back: "Back",
    confirm: "Confirm",
    areYouSure: "Are you sure?",
    thisActionCannotBeUndone: "This action cannot be undone.",
    
    // Escalation
    escalationDetails: "Escalation Details",
    escalationFormTitle: "Escalation Form",
  },

  peerEducatorTl: {
    // Peer Profile
    peerProfile: "Profile ng Peer Educator",
    accountSettings: "Mga Setting ng Account",
    personalInformation: "Personal na Impormasyon",
    fullName: "Pangalan",
    email: "Email",
    phoneNumber: "Numero ng Telepono",
    dateOfBirth: "Petsa ng Kapanganakan",
    sexAssignedAtBirth: "Kasarian Ipinanganak",
    address: "Address",
    preferredLanguage: "Gustong Wika",
    selectLanguage: "Pumili ng Wika",
    english: "English",
    filipino: "Filipino",
    saveChanges: "I-save ang Mga Pagbabago",
    cancel: "Kanselahin",
    editingProfile: "Nag-eedit ng Profile",
    editProfile: "I-edit ang Profile",
    dateCreated: "Petsa ng Nilikha",
    lastLogin: "Huling Pag-login",
    activeSessions: "Mga Aktibong Session",

    // Peer Dashboard
    dashboard: "Dashboard",
    chat: "Chat",
    resources: "Mga Resource",
    profile: "Profile",
    activeChats: "Mga Aktibong Chat",
    pendingRequests: "Mga Nakabinbing Kahilingan",
    totalResources: "Kabuuan ng mga Resource",
    recentActivity: "Kamakailang Aktibidad",

    // Peer Chats
    chats: "Mga Chat",
    newChat: "Bagong Chat",
    searchChats: "Maghanap ng mga Chat",
    open: "Bukas",
    archived: "Naka-archive",
    typeYourMessage: "I-type ang iyong mensahe",
    send: "Ipadala",
    noChatsFound: "Walang nahanap na chat",
    chatHistory: "Kasaysayan ng Chat",

    // Peer Chat Form
    selectTopic: "Pumili ng Paksa",
    hivAwareness: "Kamalayan sa HIV",
    hivScreeningTesting: "Pagsusuri sa HIV",
    birthControlImplant: "Birth Control/Implant",
    contraception: "Kontrasepsyon",
    familyPlanning: "Pagpaplano ng Pamilya",
    genderBasedViolence: "Karahasan Batay sa Kasarian",
    menstrualHealthHygiene: "Kalusugan at Kagalingan sa Menstruasyon",
    other: "Iba pa",
    specifyTopic: "Mangyaring tukuyin ang iyong paksa",
    submitRequest: "Isumite ang Kahilingan",
    chatRequest: "Kahilingan sa Chat",
    waitingForPeer: "Naghihintay para sa peer educator...",

    // Peer Resources
    resourceLibrary: "Library ng mga Resource",
    search: "Maghanap",
    filterByCategory: "I-filter ayon sa Kategory",
    allCategories: "Lahat ng Kategory",
    title: "Pamagat",
    category: "Kategory",
    addedDate: "Petsa ng Pagdagdag",
    status: "Status",
    actions: "Mga Aksyon",
    noResourcesFound: "Walang nahanap na resource",
    approved: "Naaprubahan",
    pending: "Naka-pending",
    rejected: "Nareject",
    view: "Tingnan",
    edit: "I-edit",
    delete: "I-delete",
    addResource: "Magdagdag ng Resource",

    // Peer Resource View
    resourceDetails: "Mga Detalye ng Resource",
    download: "I-download",
    share: "Ibahagi",
    backToLibrary: "Bumalik sa Library",

    // General
    loading: "Naglo-load...",
    error: "Error",
    success: "Tagumpay",
    back: "Bumalik",
    confirm: "Kumpirmahin",
    areYouSure: "Sigurado ka ba?",
    thisActionCannotBeUndone: "Hindi na mababalik ang aksyong ito.",
    selectCategory: "Pumili ng isang kategory",
    contentSettings: "Mga Setting ng Content",
    socialPreview: "Social Preview",
    editSocial: "I-edit ang Social",
    publishToApproval: "I-publish para sa Approval",
    saveAsDraft: "I-save bilang Draft",
    minorEligible: "Minor Eligible",
    publish: "I-publish",
    save: "I-save",
    pleaseAddContent: "Mangyaring magdagdag ng content bago magsumite para sa approval.",
    pleaseSelectCategory: "Mangyaring pumili ng kategory bago magsumite para sa approval.",
    submissionSuccess: "Ang content ay na-submit para sa approval!",
    draftSaved: "Ang draft ay na-save nang matagumpay!",
    description: "Deskripsyon",
  },

  // Medical Professional Translations
  medicalProfessional: {
    // Medical Profile
    medicalProfile: "Medical Professional Profile",
    accountSettings: "Account Settings",
    personalInformation: "Personal Information",
    fullName: "Full Name",
    email: "Email",
    phoneNumber: "Phone Number",
    dateOfBirth: "Date of Birth",
    sexAssignedAtBirth: "Sex Assigned at Birth",
    address: "Address",
    preferredLanguage: "Preferred Language",
    selectLanguage: "Select Language",
    english: "English",
    filipino: "Filipino",
    saveChanges: "Save Changes",
    cancel: "Cancel",
    editingProfile: "Editing Profile",
    editProfile: "Edit Profile",
    dateCreated: "Date Created",
    lastLogin: "Last Login",
    activeSessions: "Active Sessions",

    // Medical Dashboard
    dashboard: "Dashboard",
    escalatedCases: "Escalated Cases",
    reviewCases: "Review Cases",
    resolvedCases: "Resolved Cases",
    pendingCases: "Pending Cases",
    totalCases: "Total Cases",
    recentActivity: "Recent Activity",
    profile: "Profile",

    // Medical Escalated Cases
    escalatedCases: "Escalated Cases",
    search: "Search",
    filterByStatus: "Filter by Status",
    allStatus: "All Status",
    pending: "Pending",
    underAssessment: "Under Assessment",
    resolved: "Resolved",
    patientName: "Patient Name",
    topic: "Topic",
    submittedDate: "Submitted Date",
    assignedPeer: "Assigned Peer",
    actions: "Actions",
    noCasesFound: "No cases found",
    viewCase: "View Case",
    assignCase: "Assign Case",
    resolveCase: "Resolve Case",

    // Medical Escalation Form
    escalationForm: "Escalation Form",
    escalationDetails: "Escalation Details",
    escalationFormTitle: "Escalation Form",
    selectTopic: "Select Topic",
    hivAwareness: "HIV Awareness",
    hivScreeningTesting: "HIV Screening/Testing",
    birthControlImplant: "Birth Control/Implant",
    contraception: "Contraception",
    familyPlanning: "Family Planning",
    genderBasedViolence: "Gender-Based Violence",
    menstrualHealthHygiene: "Menstrual Health & Hygiene",
    other: "Other",
    specifyTopic: "Please specify your topic",
    submitEscalation: "Submit Escalation",
    escalationRequest: "Escalation Request",
    waitingForMedical: "Waiting for medical professional...",

    // General
    loading: "Loading...",
    error: "Error",
    success: "Success",
    back: "Back",
    confirm: "Confirm",
    areYouSure: "Are you sure?",
    thisActionCannotBeUndone: "This action cannot be undone.",
    noPendingAppointments: "No pending appointments",
    reviewAppointments: "Review Appointments",
    completed: "Completed",
    confirmed: "Confirmed",
    accepted: "Accepted",
    refresh: "Refresh",
    exportToPDF: "Export to PDF",
    escalationDetails: "Escalation Details",
    escalationFormTitle: "Escalation Form",
    responseMessage: "Response Message",
    recommendation: "Recommendation",
    responseType: "Response Type",
    submitResponse: "Submit Response",
    loadingMessages: "Loading messages...",
    noMessages: "No messages",
    statusUpdated: "Status updated to",
    failedToResolve: "Failed to resolve case",
    userNotAuthenticated: "User not authenticated",
  },

  medicalProfessionalEn: {
    // Medical Profile
    medicalProfile: "Medical Professional Profile",
    accountSettings: "Account Settings",
    personalInformation: "Personal Information",
    fullName: "Full Name",
    email: "Email",
    phoneNumber: "Phone Number",
    dateOfBirth: "Date of Birth",
    sexAssignedAtBirth: "Sex Assigned at Birth",
    address: "Address",
    preferredLanguage: "Preferred Language",
    selectLanguage: "Select Language",
    english: "English",
    filipino: "Filipino",
    saveChanges: "Save Changes",
    cancel: "Cancel",
    editingProfile: "Editing Profile",
    editProfile: "Edit Profile",
    dateCreated: "Date Created",
    lastLogin: "Last Login",
    activeSessions: "Active Sessions",

    // Medical Dashboard
    dashboard: "Dashboard",
    escalatedCases: "Escalated Cases",
    reviewCases: "Review Cases",
    resolvedCases: "Resolved Cases",
    pendingCases: "Pending Cases",
    totalCases: "Total Cases",
    recentActivity: "Recent Activity",
    profile: "Profile",

    // Medical Escalated Cases
    escalatedCases: "Escalated Cases",
    search: "Search",
    filterByStatus: "Filter by Status",
    allStatus: "All Status",
    pending: "Pending",
    underAssessment: "Under Assessment",
    resolved: "Resolved",
    patientName: "Patient Name",
    topic: "Topic",
    submittedDate: "Submitted Date",
    assignedPeer: "Assigned Peer",
    actions: "Actions",
    noCasesFound: "No cases found",
    viewCase: "View Case",
    assignCase: "Assign Case",
    resolveCase: "Resolve Case",

    // Medical Escalation Form
    escalationForm: "Escalation Form",
    escalationDetails: "Escalation Details",
    escalationFormTitle: "Escalation Form",
    selectTopic: "Select Topic",
    hivAwareness: "HIV Awareness",
    hivScreeningTesting: "HIV Screening/Testing",
    birthControlImplant: "Birth Control/Implant",
    contraception: "Contraception",
    familyPlanning: "Family Planning",
    genderBasedViolence: "Gender-Based Violence",
    menstrualHealthHygiene: "Menstrual Health & Hygiene",
    other: "Other",
    specifyTopic: "Please specify your topic",
    submitEscalation: "Submit Escalation",
    escalationRequest: "Escalation Request",
    waitingForMedical: "Waiting for medical professional...",

    // General
    loading: "Loading...",
    error: "Error",
    success: "Success",
    back: "Back",
    confirm: "Confirm",
    areYouSure: "Are you sure?",
    thisActionCannotBeUndone: "This action cannot be undone.",
    noPendingAppointments: "No pending appointments",
    reviewAppointments: "Review Appointments",
    completed: "Completed",
    confirmed: "Confirmed",
    accepted: "Accepted",
    refresh: "Refresh",
    exportToPDF: "Export to PDF",
    escalationDetails: "Escalation Details",
    escalationFormTitle: "Escalation Form",
    responseMessage: "Response Message",
    recommendation: "Recommendation",
    responseType: "Response Type",
    submitResponse: "Submit Response",
    loadingMessages: "Loading messages...",
    noMessages: "No messages",
    statusUpdated: "Status updated to",
    failedToResolve: "Failed to resolve case",
    userNotAuthenticated: "User not authenticated",
    profile: "Profile",
  },

  medicalProfessionalTl: {
    // Medical Profile
    medicalProfile: "Profile ng Medical Professional",
    accountSettings: "Mga Setting ng Account",
    personalInformation: "Personal na Impormasyon",
    fullName: "Pangalan",
    email: "Email",
    phoneNumber: "Numero ng Telepono",
    dateOfBirth: "Petsa ng Kapanganakan",
    sexAssignedAtBirth: "Kasarian Ipinanganak",
    address: "Address",
    preferredLanguage: "Gustong Wika",
    selectLanguage: "Pumili ng Wika",
    english: "English",
    filipino: "Filipino",
    saveChanges: "I-save ang Mga Pagbabago",
    cancel: "Kanselahin",
    editingProfile: "Nag-eedit ng Profile",
    editProfile: "I-edit ang Profile",
    dateCreated: "Petsa ng Nilikha",
    lastLogin: "Huling Pag-login",
    activeSessions: "Mga Aktibong Session",

    // Medical Dashboard
    dashboard: "Dashboard",
    escalatedCases: "Mga Kaso na Naka-escalate",
    reviewCases: "Suriin ang mga Kaso",
    resolvedCases: "Mga Naresolba na Kaso",
    pendingCases: "Mga Naka-pending na Kaso",
    totalCases: "Kabuuan ng mga Kaso",
    recentActivity: "Kamakailang Aktibidad",
    profile: "Profile",

    // Medical Escalated Cases
    escalatedCases: "Mga Kaso na Naka-escalate",
    search: "Maghanap",
    filterByStatus: "I-filter ayon sa Status",
    allStatus: "Lahat ng Status",
    pending: "Naka-pending",
    underAssessment: "Sa ilalim ng Assessment",
    resolved: "Naresolba",
    patientName: "Pangalan ng Pasyente",
    topic: "Paksa",
    submittedDate: "Petsa ng Pagsumite",
    assignedPeer: "Nakatalagang Peer",
    actions: "Mga Aksyon",
    noCasesFound: "Walang nahanap na kaso",
    viewCase: "Tingnan ang Kaso",
    assignCase: "Italaga ang Kaso",
    resolveCase: "I-resolve ang Kaso",

    // Medical Escalation Form
    escalationForm: "Form ng Escalation",
    selectTopic: "Pumili ng Paksa",
    hivAwareness: "Kamalayan sa HIV",
    hivScreeningTesting: "Pagsusuri sa HIV",
    birthControlImplant: "Birth Control/Implant",
    contraception: "Kontrasepsyon",
    familyPlanning: "Pagpaplano ng Pamilya",
    genderBasedViolence: "Karahasan Batay sa Kasarian",
    menstrualHealthHygiene: "Kalusugan at Kagalingan sa Menstruasyon",
    other: "Iba pa",
    specifyTopic: "Mangyaring tukuyin ang iyong paksa",
    submitEscalation: "Isumite ang Escalation",
    escalationRequest: "Kahilingan sa Escalation",
    waitingForMedical: "Naghihintay para sa medical professional...",

    // General
    loading: "Naglo-load...",
    error: "Error",
    success: "Tagumpay",
    back: "Bumalik",
    confirm: "Kumpirmahin",
    areYouSure: "Sigurado ka ba?",
    thisActionCannotBeUndone: "Hindi na mababalik ang aksyong ito.",
    noPendingAppointments: "Walang naka-pending na appointment",
    reviewAppointments: "Suriin ang mga Appointment",
    completed: "Nakumpleto",
    confirmed: "Nakumpirmahan",
    accepted: "Tinanggap",
    refresh: "I-refresh",
    exportToPDF: "I-export sa PDF",
    escalationDetails: "Mga Detalye ng Escalation",
    escalationFormTitle: "Form ng Escalation",
    responseMessage: "Mensahe ng Tugon",
    recommendation: "Rekomendasyon",
    responseType: "Uri ng Tugon",
    submitResponse: "Isumite ang Tugon",
    loadingMessages: "Naglo-load ng mga mensahe...",
    noMessages: "Walang mga mensahe",
    statusUpdated: "Ang status ay na-update sa",
    failedToResolve: "Nabigo ang pag-resolve ng kaso",
    userNotAuthenticated: "Hindi naka-authenticate ang user",
    profile: "Profile",
  },
  tl: {
    account: "Account",
    notifications: "Mga Abiso",
    content: "Nilalaman",
    health: "Impormasyon sa Kalusugan",
    accessibility: "Accessibility",
    privacy: "Data at Privacy",
    accesshistory: "Kasaysayan ng Pag-access",
    logout: "Mag-logout",
    deactivate: "I-deactivate ang Account",
    languagePreference: "Wika na Gusto",
    english: "English",
    tagalog: "Tagalog",

    // Top Navigation Bar
    learn: "Matuto",
    askAuri: "Magtanong kay Auri",
    records: "Mga Tala",
    appointment: "Appointment",

    // Learn Panel
    educationalHub: "Pang-edukasyon na Hub",
    suggestedArticles: "Mga Iminungkahing Artikulo",
    upNext: "Susunod",
    search: "Maghanap",

    // Ask AI Panel
    newChat: "Bagong Chat",
    searchChats: "Maghanap ng mga Chat",
    open: "Bukas",
    archived: "Naka-archive",
    typeYourMessage: "I-type ang iyong mensahe",

    // Human Support Panel
    humanSupport: "Tulong ng Peer Educator",
    hiThereYoureAboutToChat: "Kamusta! Ikaw ay makikipag-chat sa isang AuraVit Peer Educator.",
    greatChoosePreferredLanguage: "Mahusay! Bago tayo magpatuloy, mangyaring piliin ang iyong gustong wika upang maitugma tayo sa isang Peer Educator na makakausap mo nang maayos at komportable.",
    english: "English",
    tagalog: "Tagalog",
    bisaya: "Bisaya",
    excellentChooseTopic: "Napakahusay! Upang makatulong sa iyo nang mas mabuti, ano ang paksa ng iyong katanungan?",
    hivAwareness: "Kamalayan sa HIV",
    hivScreeningTesting: "Pagsusuri sa HIV",
    birthControlImplant: "Birth Control/Implant",
    contraception: "Kontrasepsyon",
    familyPlanning: "Pagpaplano ng Pamilya",
    genderBasedViolence: "Karahasan Batay sa Kasarian",
    menstrualHealthHygiene: "Kalusugan at Kagalingan sa Menstruasyon",
    other: "Iba pa",
    thankYouForSharing: "Salamat sa pagbabahagi. Maaari ka nang magpadala ng iyong katanungan o mensahe, at ang Peer Educator namin ay handang tumulong sa iyo.",
    excellentYouCanSendMessage: "Napakahusay! Maaari ka nang magpadala ng iyong katanungan o mensahe anumang oras na handa ka na.",
    yourInquirySubmittedTicket: "Naipasa na ang iyong katanungan! Numero ng tiket:",
    waitingForPeerEducator: "Naghihintay para sa isang peer educator...",

    // Records Panel
    healthRecords: "Mga Tala sa Kalusugan",
    all: "Lahat",
    uncategorized: "Hindi Naka-categorize",
    searchRecords: "Maghanap ng mga Tala",
    addCategory: "Magdagdag ng Kategorya",
    noRecordsFound: "Walang nahanap na tala",

    // Appointments Panel
    appointments: "Mga Appointment",
    bookAppointment: "Mag-book ng Appointment",
    myAppointments: "Aking Mga Appointment",
    upcoming: "Darating",
    completed: "Nakumpleto",
    cancelled: "Kinansela",
    searchAppointments: "Maghanap ng mga Appointment",

    // Notifications Panel
    notificationSettings: "Mga Setting ng Abiso",
    chooseWhatNotifications: "Piliin kung aling mga abiso ang gusto mong matanggap. Magpapadala pa rin kami ng mahahalagang update ng account.",
    enabled: "Naka-enable",
    disabled: "Naka-disable",
    active: "Aktibo",
    educationalContent: "Pang-edukasyon na Nilalaman",
    educationalContentDesc: "Maabisuhan tungkol sa mga materyales sa pag-aaral, mga tip sa kalusugan, at mga update sa edukasyon.",
    eventsActivities: "Mga Kaganapan at Aktibidad",
    eventsActivitiesDesc: "Makatanggap ng mga alerto para sa mga darating na kaganapan, workshop, at aktibidad ng komunidad.",
    systemAnnouncements: "Mga Anunsyo ng Sistema",
    systemAnnouncementsDesc: "Manatiling may alam sa mahahalagang balita, mga update ng sistema, at mga kritikal na abiso.",
    appointmentReminders: "Mga Paalala ng Appointment",
    appointmentRemindersDesc: "Kumuha ng mga napapanahong paalala at mga update tungkol sa iyong mga darating na appointment.",
    dataPrivacy: "Data at Privacy",
    dataPrivacyDesc: "Maabisuhan tungkol sa mga kahilingan sa pag-access ng data at mga update sa privacy.",
    importantNotificationsAlwaysDelivered: "Ang mahahalagang abiso tungkol sa iyong account at seguridad ay palaging maihahatid.",
    enableAll: "I-enable ang Lahat",
    disableAll: "I-disable ang Lahat",
    noNotifications: "Walang mga abiso",
    noNotificationsInCategory: "Wala ka pang mga abiso sa kategoryang ito.",

    // UserProfile - Account Information
    accountSettings: "Mga Setting ng Account",
    managePersonalInfo: "Pamahalaan ang iyong personal na impormasyon at mga kagustuhan",
    editProfile: "I-edit ang Profile",
    personalInformation: "Personal na Impormasyon",
    editPersonalInformation: "I-edit ang iyong personal na impormasyon",
    dateOfBirth: "Petsa ng Kapanganakan",
    sexAssignedAtBirth: "Kasarian na Itinalaga sa Kapanganakan",
    address: "Address",
    viewManageAccountDetails: "Tingnan at pamahalaan ang iyong mga detalye ng account",
    password: "Password",
    newPasswordDifferent: "Ang iyong bagong password ay dapat na naiiba sa iyong mga nakaraang password",
    currentPassword: "Kasalukuyang Password",
    newPassword: "Bagong Password",
    confirmNewPassword: "Kumpirmahin ang Bagong Password",
    cancel: "Kanselahin",
    updateChanges: "I-update ang Mga Pagbabago",
    updating: "Nag-a-update...",

    // UserProfile - Content Preferences
    contentPreferences: "Mga Kagustuhan sa Nilalaman",
    personalizeLearningJourney: "I-personalize ang iyong paglalakbay sa pag-aaral gamit ang mga paksang umaayon sa iyong mga layunin sa kalusugan",

    // UserProfile - Health Information
    healthHistory: "Kasaysayan ng Kalusugan",
    infoShareTailorGuidance: "Ang impormasyong pipiliin mong ibahagi ay tumutulong upang maiangkop ang patnubay at pangangalaga.",

    // UserProfile - Accessibility
    customizeExperience: "I-customize ang iyong karanasan sa pamamagitan ng pagpili ng iyong gustong wika at laki ng teksto",
    preferredLanguage: "Wika na Gusto",
    selectLanguage: "Pumili ng Wika",
    textSize: "Laki ng Teksto",
    small: "Maliit",
    medium: "Katamtaman",
    large: "Malaki",
    previewTextSize: "I-preview ang Laki ng Teksto",

    // UserProfile - Data & Privacy
    monitorManageAccess: "Subaybayan at pamahalaan ang pag-access sa iyong personal na impormasyon sa kalusugan",
    pending: "Nakabinbin",
    approved: "Naaprubahan",
    pendingRequests: "Mga Nakabinbing Kahilingan",
    approvedAccess: "Naaprubahang Pag-access",
    noPendingAccessRequests: "Walang nakabinbing kahilingan sa pag-access.",

    // UserProfile - Access History
    reviewPastCurrentAccess: "Suriin ang nakaraan at kasalukuyang pag-access sa iyong personal na impormasyon sa kalusugan",
    active: "Aktibo",
    expired: "Nag-expire na",
    noAccessHistoryFound: "Walang nahanap na kasaysayan ng pag-access.",

    // Logout Modal
    readyToLeave: "Handa nang umalis?",
    sessionEndRedirect: "Ang iyong session ay matatapos at ikaw ay ire-redirect sa pahina ng pag-login. Maaari kang bumalik anumang oras!",
    stayLoggedIn: "Manatiling naka-log in",
    logout: "Mag-log out",
    yourDataSafelySaved: "Ang iyong data ay ligtas na nai-save",

    // Deactivate Modal - Step 1
    thinkingAboutLeaving: "Nag-iisip bang umalis?",
    understandSometimesNeedBreak: "Naiintindihan namin kung minsan kailangan mo ng pahinga. Narito ang mangyayari kapag na-deactivate mo ang iyong account:",
    temporaryPause: "Pansamantalang Pahinto",
    profileHiddenButDataStored: "Ang iyong profile ay nakatago ngunit ang iyong data ay ligtas na nai-store sa loob ng 30 araw",
    easyReactivation: "Madaling Reactivation",
    logBackInWithin30Days: "Mag-log in lang ulit sa loob ng 30 araw upang maibalik ang iyong account",
    noNotifications: "Walang Mga Abiso",
    noNotificationsWhileDeactivated: "Hindi ka makakatanggap ng anumang mga abiso habang naka-deactivate",
    accountLifecyclePolicy: "Patakaran sa Lifecycle ng Account",
    toMaintainSystemIntegrity: "Upang mapanatili ang integridad ng sistema at seguridad ng data, ang mga hindi aktibong account ay sumusunod sa isang structured lifecycle:",
    twelveMonthsInactive: "12 buwang hindi aktibo → Minarkahan bilang dormant",
    thirtyDaysAfterNotification: "30 araw pagkatapos ng abiso → Pansamantalang deactivation",
    threeYearsInactive: "3 taong hindi aktibo → Naka-archive (kailangan ng verification upang maibalik)",
    dataNeverDeleted: "Ang iyong data ay hindi kailanman tinatanggal maliban kung kinakailangan ng batas o tahasang hiniling.",
    keepMyAccountActive: "Panatilihing aktibo ang aking account",
    actionIsReversible: "Ang pagkilos na ito ay maaaring bawiin. Maaari kang mag-reactivate anumang oras sa loob ng 30 araw.",
    deactivateAccount: "I-deactivate ang Account",

    // Deactivate Modal - Step 2 (Password)
    securityVerification: "Security verification",
    forYourProtectionEnterPassword: "Para sa iyong proteksyon, mangyaring ipasok ang iyong password upang kumpirmahin ang deactivation ng account.",
    whyWeNeedYourPassword: "Bakit namin kailangan ang iyong password",
    extraStepEnsuresOnlyYou: "Ang sobrang hakbang na ito ay nagsisiguro na ikaw lang ang maaaring gumawa ng mga pagbabago sa iyong account.",
    deactivationReason: "Dahilan ng Deactivation",
    enterDeactivationReason: "Ipasok ang dahilan ng deactivation",
    passwordRequired: "Kinakailangan ang password",
    deactivationReasonRequired: "Kinakailangan ang dahilan ng deactivation",
    deactivationReasonLettersOnly: "Ang dahilan ng deactivation ay dapat na mga titik lamang",
    deactivationReason20Chars: "Ang dahilan ng deactivation ay dapat na 20 character o mas kaunti",
    sessionExpiredPleaseLogIn: "Nag-expire ang session. Mangyaring mag-log in ulit.",
    incorrectPasswordPleaseTryAgain: "Maling password. Mangyaring subukan ulit.",
    verifying: "Nagbe-verify...",
    continue: "Magpatuloy",
    yourPasswordEncrypted: "Ang iyong password ay naka-encrypt at ligtas na nai-transmit.",

    // Deactivate Modal - Step 3 (OTP)
    confirmDeactivation: "Kumpirmahin ang Deactivation",
    weSentOtpToEmail: "Nagpadala kami ng one-time passcode (OTP) sa iyong email. Mangyaring ipasok ito upang kumpirmahin ang deactivation.",
    otp: "OTP",
    enterOtp: "Ipasok ang OTP",
    otpRequired: "Kinakailangan ang OTP",
    otpMustBe6Digits: "Ang OTP ay dapat na 6 digit",
    invalidOtp: "Maling OTP. Mangyaring subukan ulit.",
    resendOtp: "Ipadala muli ang OTP",
    otpSent: "Naipadala na ang OTP!",
    confirm: "Kumpirmahin",
    confirming: "Kinukumpirma...",
    makeSureCheckSpam: "Siguraduhing suriin ang iyong spam folder kung hindi mo nakikita ang email.",
    emailNotFoundPleaseTryAgain: "Hindi nahanap ang email. Mangyaring subukan ulit.",
    failedToSendVerificationCode: "Nabigong ipadala ang verification code. Mangyaring subukan ulit.",
    pleaseEnterFull6DigitCode: "Mangyaring ipasok ang buong 6-digit code",
    codeHasExpiredPleaseRequestNew: "Nag-expire na ang code. Mangyaring humingi ng bagong code.",
    noPendingDeactivationFound: "Walang nahanap na pending deactivation. Mangyaring subukan ulit.",
    incorrectCodePleaseTryAgain: "Maling code, mangyaring subukan ulit",
    deactivationFailedPleaseTryAgain: "Nabigo ang deactivation. Mangyaring subukan ulit.",
    failedToResendCode: "Nabigong ipadala muli ang code. Mangyaring subukan ulit.",
    checkYourEmail: "Suriin ang iyong email",
    weSent6DigitCode: "Nagpadala kami ng 6-digit verification code upang kumpirmahin ang iyong kahilingan sa deactivation.",
    verificationSent: "Naipadala na ang verification",
    checkInboxEnterCode: "Suriin ang iyong inbox at ipasok ang 6-digit code sa ibaba",
    whyWeNeedVerification: "Bakit namin kailangan ang verification",
    extraStepEnsuresOnlyCompleteDeactivation: "Ang sobrang hakbang na ito ay nagsisiguro na ikaw lang ang maaaring kumpletuhin ang proseso ng deactivation.",
    codeExpiresIn: "Mag-expire ang code sa loob ng",
    didntReceiveCode: "Hindi mo natanggap ang code?",
    sending: "Nagpapadala...",

    // Ask AI Panel - Onboarding
    heyThereImAuri: "Kamusta! Ako si Auri, ang iyong health sidekick.",
    beforeWeGetStarted: "Bago tayo magsimula, kailangan ko lang ipaalam sa iyo ang isang mahalagang bagay. Ang pag-uusap na ito ay hindi kapalit ng propesyonal na medikal na payo, diagnosis, o paggamot. Palaging kumonsulta sa iyong healthcare provider para sa anumang alalahaning medikal.",
    iUnderstand: "Nauunawaan Ko",
    thanksForConfirming: "Salamat sa pagkumpirma! Narito ako upang sagutin ang iyong mga katanungan tungkol sa reproductive health gamit ang mga health FAQs ng AuraVit. Magtanong ka sa akin tungkol sa mga paksa tulad ng kamalayan sa HIV, pagsusuri sa HIV, birth control, at iba pang alalahanin sa reproductive health.",
    letsGetStarted: "Magsimula Tayo",
    awesomeLetsDiveIn: "Ayos! Simulan na natin. Gusto mo bang tingnan ang iyong progreso, mag-set ng bagong goal, o kumuha ng mabilis na health tip ngayon?",
    hiThereHumanSupport: "Kamusta! Makikipag-chat ka na sa isang AuraVit Peer Educator.",
    greatYouCanSendQuestion: "Great! You can go ahead and send your question or message whenever you're ready.",
  },
};
